import axiosInstance from '../utils/axiosConfig'
import { FundsData, BrowseCategoriesResponse } from '../types/peer-analyser'

export const fetchPeerAnalyserFunds = async (selectedCategoryId: string, fundNature: string): Promise<FundsData> => {
  const response = await axiosInstance.get(
    `/v2/peer-analyser/funds?selectedCategoryId=${selectedCategoryId}&fundNature=${fundNature}`
  )
  return response.data
}

export const bookmarkFunds = async ({
  isin,
  fundCategory,
  screenSource,
  operationType
}: {
  isin: string
  fundCategory: string
  screenSource: string
  operationType: 'ADD' | 'REMOVE'
}): Promise<any> => {
  const response = await axiosInstance.post(`/v2/mutual-fund/bookmark`, {
    isin,
    fundCategory,
    screenSource,
    operationType
  })
  return response.data
}

export const subscribeToElite = async ({ fundCategory }: { fundCategory: string }) => {
  const response = await axiosInstance.post(`/v2/peer-analyser/subscribe?fundCategory=${fundCategory}`, {
    fundCategory
  })
  return response?.data
}

export const fetchBrowseCategories = async (): Promise<BrowseCategoriesResponse> => {
  const response = await axiosInstance.get(`/v2/peer-analyser/header-details`)
  if (!response?.data) {
    throw new Error('Failed to fetch browse categories')
  }
  return response.data
}

export type PeerAnalyserDisplayFilter =
  | 'RANK_AND_PERFORMANCE'
  | 'ELITE_SCORE'
  | 'ROLLING_RETURNS'
  | 'TRAILING_RETURNS'
  | 'AUM_CHANGE'
  | 'AUM_AND_FUND_AGE'

export const reorderColumns = async ({ filters }: { filters: PeerAnalyserDisplayFilter[] }): Promise<any> => {
  const response = await axiosInstance.post(`/v2/mutual-fund/bookmark`, {
    screenSource: 'PEER_ANALYSER_DISPLAY_SETTING',
    operationType: 'ADD',
    filters
  })
  return response.data
}
